require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[72],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-truncatedText{overflow:hidden;white-space:nowrap;width:100%;display:table;table-layout:fixed;text-decoration:inherit}.ba-common-truncatedText__text{white-space:nowrap;line-height:normal;display:inline-block;text-decoration:inherit}.ba-common-truncatedText__tooltip{width:100%}.ba-common-truncatedText.is-disabled{cursor:not-allowed}.ba--highContrast .ba-common-truncatedText.is-disabled{cursor:not-allowed;text-decoration:line-through}.ba-common-truncatedText{transition:opacity .2s ease-in-out}.ba-common-truncatedText.is-disabled{opacity:.5}", ""]);

// exports
exports.locals = {
	"truncatedTextClassName": "\"ba-common-truncatedText\""
};

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

module.exports = require("react-measure");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(591);


/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _TruncatedText = _interopRequireDefault(__webpack_require__(592));

exports.default = _TruncatedText.default;
exports.TruncatedText = _TruncatedText.default;

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _reactMeasure = _interopRequireDefault(__webpack_require__(29));

var _utils = __webpack_require__(5);

var _lodash = __webpack_require__(18);

var _TruncatedText = _interopRequireDefault(__webpack_require__(593));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui--carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const truncatedTextClassName = _TruncatedText.default.truncatedTextClassName.replace(/"/g, '');

const CHAR_THRESHOLD = 4;
const {
  sanitize,
  BaPropTypes
} = _utils.propsUtils;
const {
  resolveBaseTextDir
} = _utils.bidiUtils;

class TruncatedText extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "state", {
      charCount: this._handleValueType().length
    });
    (0, _defineProperty2.default)(this, "onMeasure", dimensions => {
      if (this.state.isMounted) {
        const containerWidth = Math.ceil(dimensions.entry.width);

        this._resizeText(containerWidth);
      } else {
        this._getTextWidths();
      }
    });
    (0, _defineProperty2.default)(this, "getTextNode", () => {
      const {
        title,
        textDir
      } = this.props;

      const value = this._handleValueType();

      const {
        charCount
      } = this.state;
      const initCharCount = value.length;
      const isEllipsed = charCount >= 0 && charCount < initCharCount;
      let ellipsisValue = '';

      if (isEllipsed) {
        if (charCount <= 1) {
          ellipsisValue = '\u2026';
        } else {
          const charStart = Math.floor(charCount / 2);
          const charEnd = initCharCount - Math.ceil(charCount / 2) + 1;
          ellipsisValue = this.props.location === 'middle' ? `${value.substring(0, charStart)}\u2026${value.substring(charEnd)}` : `${value.substring(0, charCount - 3)}\u2026`;
        }
      } else {
        ellipsisValue = _utils.Bidi.reshape(value, this.props.numShape);
      }

      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
        "data-tid": "ba-common-truncated-text__text-node",
        className: `${(0, _utils.classnames)(`${truncatedTextClassName}__text`)}`,
        ref: this._refText,
        "aria-label": title || value,
        dir: resolveBaseTextDir(ellipsisValue, textDir, false)
      }, this.mappedTitle(isEllipsed, value)), ellipsisValue);
    });
    (0, _defineProperty2.default)(this, "mappedTitle", (isEllipsed, value) => {
      const {
        title,
        allowTooltip,
        alwaysShowTooltip
      } = this.props;

      if (!allowTooltip) {
        return {};
      }

      if (alwaysShowTooltip && title) {
        return {
          title
        };
      }

      if (isEllipsed) {
        return {
          title: title || value
        };
      }
    });
    (0, _defineProperty2.default)(this, "_getTextWidths", () => {
      const value = this._handleValueType(); // get initial widths and char counts


      if (this._textNode) {
        this._textWidth = this._textNode.offsetWidth;
        this._initTextWidth = this._textNode.offsetWidth;
        this._initCharCount = value.length;
        this._initCharWidth = this._getCharWidth(value.length);
        this._lastTruncPos = this._initTextWidth;
        this.setState({
          isMounted: true,
          isHidden: this._textNode.offsetWidth === 0
        });
      }
    });
    (0, _defineProperty2.default)(this, "_ref", node => {
      this._node = node;

      this._measureRef(node);
    });
    (0, _defineProperty2.default)(this, "_refText", node => {
      this._textNode = node;
    });
    this.debouncedResizeText = (0, _lodash.debounce)(this._resizeText, 10);
  }

  componentDidMount() {
    // Defect 234641: Added._textNode.offsetWidth condition check to prevent truncated text with 0 max width
    if (!this._textNode.offsetWidth) {
      setTimeout(this._getTextWidths);
    } else {
      this._textNode && this._getTextWidths();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      // reset charCount to trigger measuring again
      const nextValueProp = this._handleValueType(nextProps.value);

      this.setState({
        charCount: nextValueProp.length,
        isMounted: false,
        isHidden: true
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.isMounted) {
      const containerWidth = this._node.offsetWidth;
      this._textWidth = this._textNode.offsetWidth;

      if (prevState.isMounted !== this.state.isMounted) {
        // check if resizing is still needed after first render
        this.debouncedResizeText(containerWidth);
      } else if (prevState.charCount !== this.state.charCount) {
        // keep track of position when last truncation was made
        this._lastTruncPos = containerWidth;

        if (containerWidth < this._textWidth) {
          // keep resizing until textWidth is < container
          this._shortenText(containerWidth);
        }
      }
    } else if (prevProps.value !== this.props.value) {
      // trigger measuring after updating props (i.e. in Select)
      this._getTextWidths();
    }
  }

  componentWillUnmount() {
    this.debouncedResizeText && this.debouncedResizeText.cancel();
  }

  _handleValueType(value = this.props.value) {
    return value == null ? '' : String(value);
  }

  _resizeText(containerWidth) {
    if (containerWidth < this._textWidth && containerWidth < this._lastTruncPos) {
      this._shortenText(containerWidth);
    } else if (containerWidth > this._textWidth && containerWidth < this._initTextWidth && containerWidth > this._lastTruncPos) {
      this._lengthenText(containerWidth);
    } else if (containerWidth >= this._initTextWidth && this.state.charCount !== this._initCharCount) {
      // show entire string by resetting charCount
      this._lastTruncPos = this._initTextWidth;
      this.setState({
        charCount: this._initCharCount
      });
    }
  }

  _shortenText(containerWidth) {
    const {
      charCount
    } = this.state;

    if (charCount > 0 && containerWidth > 0) {
      const charWidth = this._getCharWidth(charCount);

      const extraChars = this._getExcessChars(containerWidth, charWidth);

      const newCharCount = Math.max(0, charCount - Math.max(1, extraChars));
      this.setState({
        charCount: newCharCount
      });
    }
  }

  _lengthenText(containerWidth) {
    const value = this._handleValueType();

    const {
      charCount
    } = this.state;

    if (charCount < value.length) {
      const charWidth = this._getCharWidth(charCount);

      const diff = containerWidth - this._textWidth;

      const missingChars = this._getExcessChars(containerWidth, charWidth);

      if (diff > 1.5 * charWidth || value.length - charCount === 1) {
        const newCharCount = Math.min(value.length, charCount + missingChars);

        if (newCharCount !== charCount) {
          this.setState({
            charCount: newCharCount
          });
        }
      }
    }
  }

  _getCharWidth(charCount) {
    return charCount > CHAR_THRESHOLD ? this._textWidth / charCount : this._initCharWidth;
  }

  _getExcessChars(containerWidth, charWidth) {
    const extraChars = Math.floor((this._textWidth - containerWidth) / charWidth);
    return Math.abs(extraChars);
  }

  render() {
    const {
      className,
      textAlign,
      style,
      disabled,
      ...others
    } = this.props;
    const {
      isMounted,
      isHidden
    } = this.state;
    const containerStyle = {
      textAlign,
      // Defect 226704: Added the fallback inline styles
      // Defect 234641: Added _initTextWidth as part of condition check
      maxWidth: isMounted && this._initTextWidth !== 0 ? this._initTextWidth + 2 : '100%',
      // Defect BAUICOMMON-783: using block to display the KPI Indicator when offsetWidth is 0
      display: isMounted && !isHidden ? 'table' : 'block',
      // visibility: _isMounted ? 'visible' : 'hidden',
      ...style
    };
    const classNames = (0, _utils.classnames)(truncatedTextClassName, {
      disabled
    });
    return /*#__PURE__*/_react.default.createElement(_reactMeasure.default, {
      onResize: this.onMeasure
    }, ({
      measureRef
    }) => {
      this._measureRef = measureRef;
      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, sanitize(others, TruncatedText), {
        className: `${classNames} ${className}`,
        ref: this._ref,
        style: { ...containerStyle
        }
      }), this.getTextNode());
    });
  }

}

exports.default = TruncatedText;
(0, _defineProperty2.default)(TruncatedText, "propTypes", {
  value: _propTypes.default.string.isRequired,
  location: _propTypes.default.oneOf(['end', 'middle']),
  textAlign: _propTypes.default.oneOf(['left', 'right', 'center']),
  title: _propTypes.default.string,
  className: _propTypes.default.string,
  textDir: _propTypes.default.oneOf(['', 'ltr', 'rtl', 'auto']),
  numShape: _propTypes.default.bool,
  style: _propTypes.default.object,
  disabled: _propTypes.default.bool,
  allowTooltip: _propTypes.default.bool,
  tooltipDelay: BaPropTypes.deprecated('deprecated - browser tooltip is used '),
  alwaysShowTooltip: _propTypes.default.bool
});
(0, _defineProperty2.default)(TruncatedText, "defaultProps", {
  location: 'middle',
  className: '',
  style: {},
  allowTooltip: true
});

/***/ }),

/***/ 593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_TruncatedText_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(164);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_TruncatedText_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_TruncatedText_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_TruncatedText_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_TruncatedText_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[590,0]]]);
});